import { ECustomThemeViews } from '@olo-web/types/enums';

export type Label = {
  [ECustomThemeViews.COLOR]: string;
  [ECustomThemeViews.FONTS]?: string;
  [ECustomThemeViews.LOGO]: string;
  [ECustomThemeViews.BACKGROUND_IMAGE]: string;
  [ECustomThemeViews.FAVICON]: string;
};

export const label = {
  [ECustomThemeViews.COLOR]: 'color',
  [ECustomThemeViews.FONTS]: 'fonts',
  [ECustomThemeViews.LOGO]: 'logo',
  [ECustomThemeViews.BACKGROUND_IMAGE]: 'background image',
  [ECustomThemeViews.FAVICON]: 'favicon',
};
